// Modal de confirmación para eliminar un pago
import React, {useState} from 'react'
import {KTIcon} from '../../../../_metronic/helpers'
import {fetchWithAuth} from '../../../core/utils/fetchWithAuth'

type Props = {
  isOpen: boolean
  onClose: () => void
  idPago: string | null
  onSuccess: () => void
}

const ConfirmarEliminarPagoModal: React.FC<Props> = ({isOpen, onClose, idPago, onSuccess}) => {
  const [deleting, setDeleting] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const getToken = (): string | null => localStorage.getItem('X-TOKEN')

  const handleConfirm = async () => {
    if (!idPago) return
    const idPagoNum = parseInt(idPago, 10)
    if (isNaN(idPagoNum)) return
    try {
      setDeleting(true)
      setError(null)
      const token = getToken()
      if (!token) throw new Error('No se encontró el token de autenticación')

      const response = await fetchWithAuth(`${process.env.REACT_APP_API_URL}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-TOKEN': token,
        },
        body: JSON.stringify({
          service: 'eliminarPago',
          idPago: idPagoNum,
        }),
      })

      const data = await response.json()
      if (data.code === 'OK') {
        onSuccess()
        onClose()
      } else {
        throw new Error(data.returned_message || 'Error al eliminar el pago')
      }
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Error desconocido')
    } finally {
      setDeleting(false)
    }
  }

  if (!isOpen) return null

  return (
    <div
      className='modal fade show d-block'
      tabIndex={-1}
      role='dialog'
      aria-modal='true'
      style={{zIndex: 2000, position: 'fixed', inset: 0}}
    >
      <div
        className='modal-dialog modal-dialog-centered'
        role='document'
        style={{position: 'relative', zIndex: 2001}}
      >
        <div className='modal-content'>
          <div className='modal-header bg-danger'>
            <h3 className='modal-title text-white d-flex align-items-center'>
              <KTIcon iconName='trash' className='fs-2 me-2' />
              Eliminar pago
            </h3>
            <button
              type='button'
              className='btn btn-sm btn-icon btn-active-color-primary'
              aria-label='Cerrar'
              onClick={onClose}
            >
              <KTIcon iconName='cross' className='fs-2 text-white' />
            </button>
          </div>
          <div className='modal-body'>
            {error && (
              <div className='alert alert-danger d-flex align-items-center mb-5'>
                <KTIcon iconName='information-5' className='fs-2hx text-danger me-3' />
                <span>{error}</span>
              </div>
            )}
            <p className='text-gray-700 mb-0'>
              ¿Está seguro que desea eliminar el pago <strong>#{idPago}</strong>? Esta acción no se puede deshacer.
            </p>
          </div>
          <div className='modal-footer border-0'>
            <button type='button' className='btn btn-light' onClick={onClose} disabled={deleting}>
              Cancelar
            </button>
            <button
              type='button'
              className='btn btn-danger'
              onClick={handleConfirm}
              disabled={deleting}
            >
              {deleting ? (
                <>
                  <span className='spinner-border spinner-border-sm me-2' />
                  Eliminando...
                </>
              ) : (
                'Eliminar'
              )}
            </button>
          </div>
        </div>
      </div>
      <div className='modal-backdrop fade show' style={{zIndex: 1990}} />
    </div>
  )
}

export {ConfirmarEliminarPagoModal}
